import React from 'react'

import HelpOutlineIcon from '@mui/icons-material/HelpOutlineOutlined'
import { Tooltip } from '@mui/material'

type LabelWithTooltipProps = {
  label: string
  tooltip: string
}

const LabelWithTooltip = ({ label, tooltip }: LabelWithTooltipProps) => (
  <span style={{ alignItems: 'center', display: 'flex', gap: 4 }}>
    {label}
    <Tooltip arrow placement="top" title={tooltip}>
      <HelpOutlineIcon
        fontSize="small"
        style={{ color: '#757575', cursor: 'pointer' }}
        tabIndex={0}
        titleAccess={`About ${label}`}
      />
    </Tooltip>
  </span>
)

export default LabelWithTooltip
